import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const Why2: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    t(
      "home.why2.bullet1",
      "Access comprehensive, evidence-based medical databases in seconds."
    ),
    t(
      "home.why2.bullet2",
      "Get real-time decision support when it matters most."
    ),
    t(
      "home.why2.bullet3",
      "Reduce administrative tasks so you can focus on patient care."
    ),
    t(
      "home.why2.bullet4",
      "Keep all your data secure and regulation-compliant."
    ),
  ];

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          {/* Left Content */}
          <div className="w-full lg:w-1/2">
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#00342d] mb-8 leading-tight"
              style={{ fontFamily: "'Bruno Ace', sans-serif" }}
            >
              {t("home.why2.title", "Designed to support you 24/7")}
            </motion.h2>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="space-y-6"
            >
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-4">
                  <CheckCircleIcon className="w-6 h-6 text-[#00342d] flex-shrink-0 mt-1" />
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {benefit}
                  </p>
                </div>
              ))}
            </motion.div>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-10 text-xl font-medium text-[#00342d]"
            >
              {t(
                "home.why2.description",
                "Enhance your practice with continuous support."
              )}
            </motion.p>
          </div>

          {/* Right Image - Static & Clean */}
          <div className="w-full lg:w-1/2">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="relative rounded-2xl overflow-hidden border border-gray-200 shadow-lg"
            >
              <img
                src="/images/home/why/platform-vettconsult2.webp"
                alt="VettConsult Platform"
                className="w-full h-auto object-cover"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why2;
